import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import StatelessBillDetail from 'saas/common/bill/StatelessBillDetail';
import { getForm } from '../reducers/form';
import { fetchForm, updateForm } from '../actions/form';
import {
  Segment,
  Input,
  Form,
  Header,
  Grid,
  Button,
  Icon,
} from 'semantic-ui-react';
import shallowEqual from 'recompose/shallowEqual';

const mapStateToProps = (state, _) => ({
  form: getForm(state),
});

const mapDispatchToProps = (dispatch, _) => ({
  fetchForm: id => dispatch(fetchForm(id)),
  updateForm: data => dispatch(updateForm(data)),
});

class Page extends Component {
  constructor(props) {
    super(props);

    this.onBillChange = this.onBillChange.bind(this);
    this.onTitleChange = this.onTitleChange.bind(this);
  }

  componentWillMount() {
    this.props.fetchForm(this.props.id);
  }

  shoudComponentUpdate(nextProps, nextState) {
    return (
      !shallowEqual(this.props, nextProps) ||
      !shallowEqual(this.state, nextState)
    );
  }

  onTitleChange = evt => {
    this.props.updateForm({
      ...this.props.form,
      estimate_title: evt.target.value,
    });
  };

  onBillChange = content => {
    this.props.updateForm({
      ...this.props.form,
      lines: content.lines,
      text_before_lines: content.textBeforeLines,
      text_after_lines: content.textAfterLines,
    });
  };

  render() {
    const { form } = this.props;

    return (
      <Form>
        <Segment>
          <Header as="h3">Créer un devis</Header>
          <Grid>
            <Grid.Column width={10}>
              <Form.Field>
                <label>Entête devis</label>
                <Input
                  placeholder="Entête devis"
                  onChange={this.onTitleChange}
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column width={6} className="bottom aligned">
              <Button icon labelPosition="left" id="ChooseDocumentModel">
                <Icon name="plus" />
                Choisir un modèle de document
              </Button>
            </Grid.Column>
          </Grid>
        </Segment>
        {form && (
          <StatelessBillDetail
            lines={form.lines || []}
            textBeforeLines={form.text_before_lines}
            textAfterLines={form.text_after_lines}
            onChange={this.onBillChange}
          />
        )}
      </Form>
    );
  }
}

Page.propTypes = {
  id: PropTypes.number.isRequired,
  form: PropTypes.object.isRequired,
  fetchForm: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step4/components/Page.js